import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { VOICE_MAIL } from 'constants/audioRecordings';

const selectAudioRecordings = ({ audioRecordings }) => audioRecordings.recordings;
export const selectIsUploading = ({ audioRecordings }) => audioRecordings.isUploading;

export const selectAudioRecordingsValues = createSelector(selectAudioRecordings, Object.values);

export const selectAudioRecordingById = memoizeOne(id =>
  createSelector(selectAudioRecordings, audioRecordings => audioRecordings[id]),
);

export const selectVoiceMailAudioRecordings = createSelector(
  selectAudioRecordingsValues,
  audioRecordings => audioRecordings.filter(({ type }) => type === VOICE_MAIL),
);
